import { useRef } from 'react';

import * as St from './HorizontalScrollContainer.styles';

import ArrowButton from '~atoms/ArrowButton';

type HorizontalScrollContainerProps = {
  children: React.ReactNode;
  goToNext?: () => void;
  goToPrev?: () => void;
  nextIndex?: number;
  prevIndex?: number;
  currentIndex?: number;
};

const HorizontalScrollContainer = ({
  children,
  goToNext,
  goToPrev,
  nextIndex,
  prevIndex,
  currentIndex,
}: HorizontalScrollContainerProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const scrollTo = (direction: 'left' | 'right', startOver?: boolean) => () => {
    const el = ref.current;

    if (el) {
      const xAxis = direction === 'left' ? -1 : 1;

      if (startOver && direction === 'right') {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (startOver && direction === 'left') {
        el.scrollTo({
          left: el.scrollWidth - el.clientWidth,
          behavior: 'smooth',
        });
      } else {
        const scrollAmount = 100 * xAxis; // 100 is the size of the miniatures in the small carousel

        el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  return (
    <St.Container>
      <div style={{ position: 'relative', width: '90rem' }}>
        <ArrowButton
          direction="left"
          handleClick={() => {
            goToPrev?.();
            scrollTo('left', (prevIndex ?? 0) > (currentIndex ?? 0))();
          }}
          ariaProps={{ 'aria-label': 'Scroll Left' }}
          iconStyleProps={{ fontSize: '30rem' }}
          btnStyleProps={{ left: '-15rem' }}
        />
      </div>
      <St.List
        ref={ref}
        tabIndex={0}
        role="region"
        aria-labelledby="scrollable-region-label"
      >
        {children}
      </St.List>
      <div style={{ position: 'relative', width: '100rem' }}>
        <ArrowButton
          direction="right"
          handleClick={() => {
            goToNext?.();
            scrollTo('right', (nextIndex ?? 0) < (currentIndex ?? 0))();
          }}
          ariaProps={{ 'aria-label': 'Scroll Right' }}
          iconStyleProps={{ fontSize: '30rem' }}
          btnStyleProps={{ right: '-15rem' }}
        />
      </div>
    </St.Container>
  );
};

export default HorizontalScrollContainer;
